<div class="login-page"  *ngIf="Globals.lang != ''">


	<div class="top-menu">
		<div class="header-logo">{{ 'smart_road' | translate }}</div>

		<app-clock></app-clock>

	    <ng-select [items]="Globals.langList"
		    class="lang-select"
		    bindLabel="name"
		    bindValue="code"
		    [multiple]="false"
		    [closeOnSelect]="true"
		    [selectOnTab] = "true"
		    [(ngModel)]="Globals.lang_select"
		    (ngModelChange) = "changeLang_new()"
		    [clearable]="false"
		    [searchable]="false"
		    id="lang_select"
		    >
		    <ng-template ng-header-tmp>
		      <div class="lang-sel-head">{{ 'inter_lang' | translate }}</div>
		    </ng-template>
	    </ng-select>
	</div>

	<!-- блок логина -->
	<ng-container *ngIf = "!show_new_pass">
		<div class="form" >
			<div class="form-head">{{ 'sign-in' | translate }}</div>

			<form autocomplete="off" #loginForm=ngForm (ngSubmit)="onSubmit()">
				<div class="form-group">
					<label for="email">{{'user_login' | translate}} / {{ 'email' | translate }}</label>
					<input [(ngModel)]="form.email" id="email" name="email" type="email" class="form-control validate" autocomplete="" required (keyup)="onKey($event)">
				</div>

				<div class="form-group">
					<label for="password">{{ 'password' | translate }}</label>
					<input [(ngModel)]="form.password" id="password" name="password" type="password" class="form-control validate" required (keyup)="onKey()">
				</div>
				<div class="form-group button-box">
					<button *ngIf="login_done" type="submit" [disabled] = "!loginForm.valid">{{ 'login' | translate }}</button>
					<div *ngIf="!login_done" class="loading-pulse"></div>
				</div>
		  		<div *ngIf="showErrors" class="alert alert-danger error-block">{{ 'error_auth' | translate }}</div>
			</form>
	  		<div class="form-link"><a href="#" routerLink="/auth/request-password-reset">{{ 'reset-password-link' | translate }}</a></div>

	  	</div>
	</ng-container>

  	<!-- блок смены пароля, показывается если у юзер отмечен параметр pass_change_on_login -->
  	<ng-container *ngIf = "show_new_pass">
		<div class="form" >
			<div class="form-head res-head">{{ 'change_password' | translate }}</div>
			<div class="res-text">{{ 'new_pass_message' | translate }}</div>

			<form autocomplete="off" #newloginForm=ngForm (ngSubmit)="onSubmit();savePass()">
				<div class="form-group">
					<label for="userpass_1">{{ 'new_password' | translate }}</label>
            		<input [(ngModel)]="userpass_1" (keyup)="passCheck()" class="form-control" name="userpass_1" id="userpass_1" type="password">
				</div>

				<div class="form-group">
					<label for="userpass_2">{{ 'confirm_new_password' | translate }}</label>
            		<input [(ngModel)]="userpass_2" (keyup)="passCheck()" class="form-control" name="userpass_2" id="userpass_2" [ngClass]="check_class" type="password">
				</div>
				<div class="form-group button-box">
					<button type="submit" [disabled] = "!pass_check">{{ 'cr_ro_di_used_in_continue' | translate }}</button>
				</div>
		  		<div *ngIf="showErrors" class="alert alert-danger error-block">{{ 'error_auth' | translate }}</div>
			</form>
	  	</div>
  	</ng-container>
</div>
